import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from '@material-ui/core';

function DealershipIcon({ size = 'medium', color, ...rest }) {
  const sizeMap = {
    small: {width: 18, height: 18},
    medium: {width: 24, height: 24},
    large: {width: 30, height: 30}
  };

  return (
    <SvgIcon {...rest}>
      <svg id="dealership" xmlns="http://www.w3.org/2000/svg" width={sizeMap[size].width} height={sizeMap[size].height} viewBox="0 0 1300.835 719.5">
        <path id="Path_6" dataName="Path 6" d="M133.334,386.311V300.735s441.885-106.124,623.638-78.387S903.138,386.311,903.138,386.311" transform="translate(188.966 -217.725)" fill="#fff"/>
        <path id="Path_5" dataName="Path 5" d="M0,104.055S400.737-1.968,725.946-1.968s574.889,106.023,574.889,106.023V525.5s-156.66,57.94-549.518,63.238S0,525.5,0,525.5Z" transform="translate(0 130.417)" fill="#fff"/>
        <path id="Path_7" dataName="Path 7" d="M0,77.464S330.5-1.968,598.712-1.968s474.131,79.432,474.131,79.432V397.247s-129.2,39.367-453.206,43.336S0,398.573,0,398.573Z" transform="translate(146.71 225.647)" fill={color} />
        <line id="Line_7" dataName="Line 7" y2="413" transform="translate(743.941 276.5)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="60"/>
        <line id="Line_8" dataName="Line 8" y2="373" transform="translate(1045.941 302.5)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="60"/>
        <line id="Line_10" dataName="Line 10" y2="399" transform="translate(447.941 276.5)" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="60"/>
        <path id="Path_8" dataName="Path 8" d="M1091.353,167.2S997,124.841,804.045,124.841,322.719,167.2,322.719,167.2" fill="none" stroke="#d5d5d5" strokeWidth="15"/>
        <path id="Path_9" data-name="Path 9" d="M1440.968,167.2s-137.275-42.362-417.991-42.362S322.719,167.2,322.719,167.2" transform="translate(-198.712 302.054)" fill="none" stroke="#fff" strokeWidth="50"/>
      </svg>
    </SvgIcon>
  );
}

DealershipIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};

export default DealershipIcon;
